import { useNavigate, useParams } from 'react-router-dom';
import { ESDM_ITEMS, ESDM_LEVEL_AGE_BANDS, getEsdmDomainRollup } from '@aba-denver/core';
import type { EsdmLevel } from '@aba-denver/core';
import { useData } from '../contexts/DataContext';

const LEVELS: EsdmLevel[] = [1, 2, 3, 4];

export function EsdmLevels() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getChildById, getChildEsdmProgress } = useData();

  const child = id ? getChildById(id) : undefined;

  if (!child) {
    return <div className="empty-state">Paciente não encontrado.</div>;
  }

  const progressDoc = getChildEsdmProgress(child.id);
  const rollup = getEsdmDomainRollup(ESDM_ITEMS, progressDoc?.items ?? {});

  return (
    <div>
      <div className="page-header">
        <div>
          <a onClick={() => navigate(`/patients/${child.id}`)} style={{ cursor: 'pointer', fontSize: 13 }}>
            ‹ {child.name}
          </a>
          <h1 style={{ marginTop: 6 }}>Checklist ESDM</h1>
        </div>
        <button className="btn secondary" onClick={() => navigate(`/patients/${child.id}/esdm/report`)}>
          Ver resumo
        </button>
      </div>

      <div className="stack">
        {LEVELS.map((level) => {
          const domainsInLevel = rollup.filter((r) => r.level === level);
          const acquired = domainsInLevel.reduce((sum, r) => sum + r.acquired, 0);
          const total = domainsInLevel.reduce((sum, r) => sum + r.total, 0);
          const pct = total > 0 ? Math.round((acquired / total) * 100) : 0;
          return (
            <div
              key={level}
              className="card"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/patients/${child.id}/esdm/${level}`)}
            >
              <div className="row" style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ fontWeight: 600 }}>Nível {level}</div>
                  <div className="muted" style={{ fontSize: 13 }}>{ESDM_LEVEL_AGE_BANDS[level]}</div>
                </div>
                <div className="muted" style={{ fontSize: 13 }}>{acquired} de {total} adquiridos</div>
              </div>
              <div className="progress-track" style={{ marginTop: 10 }}>
                <div className="progress-fill" style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
